module.exports = __webpack_public_path__ + "graphics/checkout-cloud-left.ckh.c1442d6095a1bdea258b765c040bdbed.svg";